<template>
  <section class="gridClass my-8">
    <slot name="title"></slot>
    <div
      v-if="!slots.title"
      class="text-xl laptop:text-2xl font-bold text-center mb-10"
    >
      {{ details.title }}
    </div>
    <div class="w-full flex justify-between flex-col laptop:flex-row">
      <div
        v-for="item in details.items"
        :key="item.id"
        class="flex flex-col justify-start items-center rounded-xl overflow-hidden mb-6 laptop:w-[30%]"
        :class="details.boxClass"
      >
        <NuxtLink :to="item.url" class="w-full text-sm text-center">
          <NuxtImg
            sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
            width="1000"
            height="1000"
            loading="lazy"
            format="webp"
            class="w-full laptop:w-[300px] laptop:h-[224px] mx-auto mb-4"
            :class="details.imgClass"
            :src="item.img"
            :alt="item.text"
          />
          {{ item.text }}
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useSlots } from "vue";

defineProps({
  details: Object,
});

const slots = useSlots();
</script>
